import { DIAGNOSTICS_REGULAR_DATE_FORMAT } from '@/const';
import { format, sub } from 'date-fns';

export const DEFAULT_DATE_PICKER_DATES = {
  from: format(sub(new Date(), { months: 2 }), DIAGNOSTICS_REGULAR_DATE_FORMAT),
  to: format(new Date(), DIAGNOSTICS_REGULAR_DATE_FORMAT),
};
